import React from 'react';
import style from './Rank.module.css';

const Rank = ({ name, emoji, minScore, maxScore, vibe, isCurrentRank }) => {
	return (
		<div className={`${style.RankWrapper} ${isCurrentRank ? style.CurrentRank : ''}`}>
			<span className={style.RankEmoji}>{emoji}</span>
			<div className={style.RankInfo}>
				<span className={style.RankName}>{name}</span>
				<span className={style.RankVibe}>{vibe}</span>
			</div>
			<span className={style.RankXP}>
				{minScore.toLocaleString()} — {maxScore === Infinity ? '∞' : maxScore.toLocaleString()} XP
			</span>
		</div>
	);
};

export default Rank;
